module.exports = { id: "phone", url: "/build/app/img/symbols.svg#phone", viewBox: "", toString: function() { return this.url; } };